module.exports = __webpack_public_path__ + "static/7-d809d5c2662398e20dcd9c1853f5d51c.jpg";